module.exports = __webpack_public_path__ + "img/mp4.2248b8fe.png";